<template>
  <div class="mediaBackground">
        <v-lazy
        v-model="isActive"
        :options="{
          threshold: .5
        }"
      >
  <v-card flat
    :width ="$vuetify.breakpoint.xs ? '70vw' : '40vw'" 
    class="mx-auto justify-center"
    height="100%"
  >  

    <v-card-text class="mediaDiv m4u_tertiary justify-center" v-if="mediatype === 2">
      <a :href="sasKey" 
  target="popup" 
  onclick="window.open(sasKey,'popup','width=85vw,height=85vw'); return false;">
   <v-img 
      class="white--text align-end imageTag"
      max-width="100%"
      height="100%"
      :src="sasKey"
      contain
    >
    </v-img>
      </a>
    </v-card-text>


    <div class="mediaDiv m4u_tertiary" v-if="mediatype === 1">
        <video controls controlsList="nodownload" :src="sasKey" 
          max-width ="85%" class="videoTag"></video>
    </div>

          <v-btn
          v-if="mediaFeature === 1 && edit === true  && mediaUser === user.UserID"
            class="teal--text text--accent-4"
            text
          >
            Featured
          </v-btn>
            <v-btn
           v-if="mediaFeature === 2 && edit === true  && mediaUser === user.UserID"
            class="teal--text text--accent-4"
            text
            @click="makeFeature(mediaLocs)"
          >
            Feature
          </v-btn>
          <v-btn
          v-if="edit === true  && mediaUser === user.UserID"
            class="teal--text text--accent-4"
            text
            v-on:click="deleteMedia(mediaLocs)"
          >
            Delete
          </v-btn>
  </v-card>
        </v-lazy>
  </div>
</template>
<script>

import EventService from '@/services/EventService.js'; 



export default {
   name: "MediaCard",

   props: ["mediaLocs", 
            "mediatype",
            "mediaUser",
            'mediaFeature',
            'edit'],

  data() {
    return {
      isActive: false,
      sasKey: '',
      reload: 0,
           absolute: true,
      opacity: .5,
      overlay: false,
       }
    },

    mounted() {
    this.getSASKey();
  },

  computed: {
      imageCheck() {
        if(this.sasKey) {
          return this.sasKey
        } else {
            switch(this.mediatype) {
              case 1:
                return 'http://localhost:8080/writing.ng'

              case 2:
                return 'http://localhost:8080/interview.png'

              case 3:
                return 'http://localhost:8080/recipe.png'

              case 4:
                return 'http://localhost:8080/traditions.png'

              default:
                return 'http://localhost:8080/writing.png'
            }
        }
        },
    user(){
    return this.$store.state.user
  },
    },
  
  methods: {
    async getSASKey() {
      // NEW - Use the eventService to call the getEvents() method
      EventService.getSASKey(this.mediaLocs)
      .then(
        (sasKey => {
          this.$set(this, "sasKey", sasKey);
        }).bind(this)

      );
    },
    async makeFeature(mediaLocs) {
        await EventService.makeFeature(mediaLocs)
            .then( () => {
      this.$emit('reloadMedia', 'featureMedia')
      this.$nextTick()
    }
    )
    },
    async deleteMedia(mediaLocs) {
    await EventService.deleteMedia(mediaLocs)
    .then( () => {
      this.$emit('reloadMedia', 'deletedMedia')
      this.$nextTick()
    }
    )
    }
  }
};
</script>
<style lang="scss" scoped>
.card {
  background-position: center;
  background-size: cover;
  text-align: center;
}
.card-content {
  padding-top: 50px;
  margin-top: 200px;
  position: absolute;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.35);
  top: 0;
  padding: 10px;
  height: 200px;
  width: 100%;

  }

  .imageTag {
    margin-top: 5px;
    margin: 0 auto;
    object-fit: contain;
    max-width: 100%;
    max-height: 100%;
  }

  
  .mediaBackground {
    width: 100%;
  }

  .mediaCard {
    margin-top: 5px;
    background-color: "primary";

  }

  .mediaDiv {
    height: 200px;
    justify-content: center;
    margin: 0 auto;

  }

  .storySummary {
    width: 80%;
    text-align: left;
    height: 20px;
    overflow: hidden;
  }

  .videoTag {

    max-height: 200px;
    max-width: 100%;
    margin: 0 auto;
  }

  span {
    font-size: 18px;
    text-align: center;
    width: 100%;
    position: absolute;
    bottom: 10px;
    right: 0;
  }
  h2 {
    margin-top: 10px;
  }

</style>